import * as actionTypes from "./TaskPlannerTypes";

const INITIAL_STATE = {
    openTasksList: [],
    taskDetails: {},
    myDayList: [],
    yesterdayList: [],
    dependencyList: [],
    myDependencyList: [],
    assignedByMeList: [],
    delayReasonsList: [],
    taskPlannerStatusList: [],
    taskWorkLog: [],
    taskPlannerReasonsList: [],
    taskTypeList: [],
    myDayWiseHoursList: [],
    myDayHeaderCount: [],
    myOpenTaskHeaderCount: [],
    planList: [],
    calendarPlanData: [],
    userList: [],
    projectList: [],
    myTeamList: [],
    myTeamPlannedHoursList: [],
    myTeamLogWorkList: [],
    taskAttachmentList: [],
    logWorkList: [],
    viewingEmployee: {},
    myTeamEmployeeDropdown: [],
    myTeamDivisionList: [],
    myTeamManagerList: [],
    userListByProject: [],
    projectCalendarData: [],
    projectTotalHours: [],
    personalInsightsTileData: [],
    planningTrend: [],
    planVsLogTrend: [],
    dependencyHandlingTrend: [],
    levelWiseLoggedHours: [],
    clusterAnalysisList: [],
    clusterAllocationsList: [],
};

const TaskPlannerReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SET_OPEN_TASKS_LIST:
            return {
                ...state,
                openTasksList: action.payload.list,
            };
        case actionTypes.SET_TASK_DETAILS:
            return {
                ...state,
                taskDetails: action.payload.list,
            };
        case actionTypes.SET_MY_DAY_LIST:
            return {
                ...state,
                myDayList: action.payload.list,
            };
        case actionTypes.SET_YESTERDAY_LIST:
            return {
                ...state,
                yesterdayList: action.payload.list,
            };
        case actionTypes.SET_DEPENDENCY_LIST:
            return {
                ...state,
                dependencyList: action.payload.list,
            };
        case actionTypes.SET_MY_DEPENDENCY_LIST:
            return {
                ...state,
                myDependencyList: action.payload.list,
            };
        case actionTypes.SET_ASSIGNED_BY_ME_LIST:
            return {
                ...state,
                assignedByMeList: action.payload.list,
            };
        case actionTypes.SET_DELAY_REASONS_LIST:
            return {
                ...state,
                delayReasonsList: action.payload.list,
            };
        case actionTypes.SET_TASK_PLANNER_STATUS_LIST:
            return {
                ...state,
                taskPlannerStatusList: action.payload.list,
            };
        case actionTypes.SET_TASK_WORK_LOG:
            return {
                ...state,
                taskWorkLog: action.payload.list,
            };
        case actionTypes.SET_TASK_PLANNER_REASONS_LIST:
            return {
                ...state,
                taskPlannerReasonsList: action.payload.list,
            };
        case actionTypes.SET_TASK_TYPE_LIST:
            return {
                ...state,
                taskTypeList: action.payload.list,
            };
        case actionTypes.SET_MY_DAY_WISE_HOURS_LIST:
            return {
                ...state,
                myDayWiseHoursList: action.payload.list,
            };
        case actionTypes.SET_MY_DAY_HEADER_COUNT:
            return {
                ...state,
                myDayHeaderCount: action.payload.list,
            };
        case actionTypes.SET_MY_OPEN_TASK_HEADER_COUNT:
            return {
                ...state,
                myOpenTaskHeaderCount: action.payload.list,
            };
        case actionTypes.SET_PLAN_LIST:
            return {
                ...state,
                planList: action.payload.list,
            };
        case actionTypes.SET_CALENDAR_PLAN_DATA:
            return {
                ...state,
                calendarPlanData: action.payload.list,
            };
        case actionTypes.SET_USER_LIST:
            return {
                ...state,
                userList: action.payload.list,
            };
        case actionTypes.SET_PROJECT_LIST:
            return {
                ...state,
                projectList: action.payload.list,
            };
        case actionTypes.SET_MY_TEAM_LIST:
            return {
                ...state,
                myTeamList: action.payload.list,
            };
        case actionTypes.SET_MY_TEAM_PLANNED_HOURS_LIST:
            return {
                ...state,
                myTeamPlannedHoursList: action.payload.list,
            };
        case actionTypes.SET_MY_TEAM_LOG_WORK_LIST:
            return {
                ...state,
                myTeamLogWorkList: action.payload.list,
            };
        case actionTypes.SET_TASK_ATTACHMENT_LIST:
            return {
                ...state,
                taskAttachmentList: action.payload.list,
            };
        case actionTypes.SET_LOG_WORK_LIST:
            return {
                ...state,
                logWorkList: action.payload.list,
            };
        case actionTypes.SET_VIEWING_EMPLOYEE:
            return {
                ...state,
                viewingEmployee: { ...action.payload },
            };
        case actionTypes.SET_MY_TEAM_EMPLOYEE_DROPDOWN:
            return {
                ...state,
                myTeamEmployeeDropdown: action.payload,
            };
        case actionTypes.SET_MY_TEAM_DIVISION_LIST:
            return {
                ...state,
                myTeamDivisionList: action.payload.list,
            };
        case actionTypes.SET_MY_TEAM_MANAGER_LIST:
            return {
                ...state,
                myTeamManagerList: action.payload.list,
            };
        case actionTypes.SET_USER_LIST_BY_PROJECT:
            return {
                ...state,
                userListByProject: action.payload.list,
            };
        case actionTypes.SET_PROJECT_CALENDAR_DATA:
            return {
                ...state,
                projectCalendarData: action.payload.list,
            };
        case actionTypes.SET_PROJECT_TOTAL_HOURS:
            return {
                ...state,
                projectTotalHours: action.payload.list,
            };
        case actionTypes.SET_PERSONAL_INSIGHTS_TILE_DATA:
            return {
                ...state,
                personalInsightsTileData: action.payload.list,
            };
        case actionTypes.SET_PLANNING_TREND:
            return {
                ...state,
                planningTrend: action.payload.list,
            };
        case actionTypes.SET_PLAN_VS_LOG_TREND:
            return {
                ...state,
                planVsLogTrend: action.payload.list,
            };
        case actionTypes.SET_DEPENDENCY_HANDLING_TREND:
            return {
                ...state,
                dependencyHandlingTrend: action.payload.list,
            };
        case actionTypes.SET_LEVEL_WISE_LOGGED_HOURS:
            return {
                ...state,
                levelWiseLoggedHours: action.payload.list,
            };
        case actionTypes.SET_CLUSTER_ANALYSIS_LIST:
            return {
                ...state,
                clusterAnalysisList: action.payload.list,
            };
        case actionTypes.SET_CLUSTER_ALLOCATIONS_LIST:
            return {
                ...state,
                clusterAllocationsList: action.payload.list,
            };
        default:
            return state;
    }
};

export default TaskPlannerReducer;